import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../API';
import { RootState } from '../store';
import { AuthInfo } from '../Types/ReDoc/Auth';

interface AuthState extends AuthInfo {
	loading: 'idle' | 'pending' | 'succeeded' | 'failed';
	error?: string;
}

const initialState: AuthState = {
	avatarUrl: null,
	mortal: false,
	roles: [],
	rules: [],
	userContactId: '',
	userLoggedStatus: false,
	userName: '',
	version: '',
	versionDate: '',
	loading: 'idle',
};

export const getUserInfo = createAsyncThunk('userInfo/Get', async () => {
	const response = await api.Auth.getUserInfo();
	return response;
});

export const authSlicer = createSlice({
	name: 'auth',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getUserInfo.pending, (state) => {
			state.loading = 'pending';
		});
		builder.addCase(getUserInfo.fulfilled, (state, action) => {
			if (action.payload) {
				window.RDC.localStorage.setItem(
					'userInfo',
					JSON.stringify(action.payload),
				);
				return {
					...action.payload,
					loading: 'succeeded',
				};
			}
		});
		builder.addCase(getUserInfo.rejected, (state, action) => {
			state.error = action.error.message;
			state.loading = 'failed';
		});
	},
});

export const getUserInfoSelector = (store: RootState): AuthState => {
	return store.auth;
};

export default authSlicer;
